import * as React from "react";
import { Input, Button, Form } from "antd";
import { withTranslation, WithTranslation } from "react-i18next";
import { observer } from "mobx-react";
import { I18N_NS } from "Config/i18n";
import { API } from "General/API";
import { API_URL } from "General/APIEndpoints";
import { RouterStore } from "Config/CustomBrowserRouter";
import { Modal } from "Components/General/Modal/GenericModal";

interface UserVerificationProps extends WithTranslation {
  projectId: number;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onSuccess: () => Promise<any>;
}

interface UserVerificationState {
  loading: boolean;
  invalidCodeError: boolean;
}

export const UserVerification = withTranslation(I18N_NS.PROJECT)(
  observer(
    class extends React.Component<UserVerificationProps, UserVerificationState> {
      readonly state: UserVerificationState = { loading: false, invalidCodeError: false };

      handleFinish = async ({ stringValue }) => {
        // eslint-disable-next-line no-async-promise-executor
        await new Promise<void>(async (res, rej) => {
          try {
            this.setState({ loading: true });
            await API.newData(API_URL.PROJECTS.verifySecureCloudAccess(this.props.projectId), { stringValue });
            res();
          } catch (error) {
            // Invalid activation code for Secure Cloud Project
            if (error.response && error.response.data && error.response.data.code === 1065) {
              this.setState({ invalidCodeError: true });
            } else {
              rej(error);
              throw error;
            }
          } finally {
            this.setState({ loading: false });
          }
        })
          .then(() => this.props.onSuccess())
          .catch((error) => {
            throw error;
          });
      };

      render() {
        const { loading, invalidCodeError } = this.state;
        const { t } = this.props;

        return (
          <Modal
            title={t("Access to the Secure Cloud project")}
            open={true}
            footer={null}
            width="100%"
            style={{ maxWidth: 600 }}
            onCancel={() => RouterStore.push("/dashboard")}
          >
            <Form onFinish={this.handleFinish} requiredMark={false} layout="vertical">
              <p>
                {t(
                  // eslint-disable-next-line max-len
                  "For the first access of this Secure Cloud project, please enter an activation code which you have received by e-mail."
                )}
              </p>
              <Form.Item
                label={t("Activation code")}
                validateStatus={invalidCodeError ? "error" : undefined}
                help={invalidCodeError ? t("Activation code is invalid") : undefined}
                name="stringValue"
                rules={[{ required: true, message: t("This field is required") }]}
              >
                <Input autoFocus={true} />
              </Form.Item>
              <div className="text-right">
                <Button type="primary" htmlType="submit" loading={loading}>
                  {t("Open project")}
                </Button>
              </div>
            </Form>
          </Modal>
        );
      }
    }
  )
);
